
export default {
  props: {
    link: {
      type: String,
      required: false,
    },
    isExternal: {
      type: Boolean,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    useFunction: {
      type: Boolean,
      required: false,
    },
  },
}
